export default "__VITE_ASSET__CIKyp01X__"